'use strict';

const processInclude = require('base/util');

$(document).ready(function () {
    //processInclude(require('base/search'));
    processInclude(require('./search/search'));
});
